import { UrlConstants } from "../url.constants";
export class ApiCommentConstants {
    static URL = UrlConstants.API_V2 + "Comment";
    static FUNCTION_GET_COMMENTS_BY_JOBID = "GetAFLAPortalCommentViewsForApplicantByJobID";
}
